(function () {
	'use strict';

	angular
	.module('core')
	.directive('userTemplate', userTemplate);

	userTemplate.$inject = ['$rootScope', '$timeout'];

	function userTemplate($root, $timeout) {
		return {
			restrict: 'E',
			templateUrl: './templates/directives/user-template.html',
			scope:{
				'src':'=',
				'value':'=?'
			},
			link: function($scope, elem, attrs) {
				var vm = $scope;

				vm.attrs = attrs;

				vm.expanded = false;

				vm.isObject = function(item){
					return item != undefined && (typeof item == 'object') && (Object.keys(item).length > 0);
				}

				vm.getValue = function(){
					var _value;

					if($root.currentMatch != undefined && $root.currentItem != undefined){
						_value = $root.currentMatch.match_key[$root.currentItem];
					}

					return _value;
				}

				vm.getKey = function(key){
					var tmp = [];
					var par = vm;
					tmp.push(key);

					while(par.$parent.$parent.key != undefined || par.$parent.$parent.$parent.key != undefined){
						if(par.$parent.$parent.key != undefined){
							par = par.$parent.$parent;
						}
						else if(par.$parent.$parent.$parent.key != undefined){
							par = par.$parent.$parent.$parent;
						}
						tmp.push(par.key);
					}
					tmp.reverse();

					return tmp.join('|');
				}
				vm.checkKey = function(key){
					var _return = false;
					if(vm.getValue() != undefined){
						_return = (vm.getValue() == vm.getKey(key));
					}
					return _return;
				}

				vm.setValue = function(key){
					$timeout(function(){
						$root.currentMatch.match_key[$root.currentItem] = vm.getKey(key);
						delete $root.currentItem;
					})
				}
			}
		}
	}
})();